import React, {Fragment} from 'react';
import TarifarioYDisponibilidad from 'components/nuevoTarifario/TarifarioYDisponibilidad';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import DatosDemograficos from 'components/nuevoTarifario/DatosDemograficos';
import PasoAPasoHorizontal from 'components/pasoAPasoHorizontal';
import { Card, CardContent, Typography } from '@mui/material';
import Cobertura from 'components/nuevoTarifario/Cobertura';
import { useSelector } from 'react-redux';
import DatosDeLMedioEscrito from 'components/nuevoTarifario/DatosDelMedioEscrito';

const NuevoMedioEscrito= ({title, openFullScreenDialog, handleClose, datosDeEmpresa, ...rest}) => {
  const {activeStep, numberStep, datosDelMedioEscrito, tarifarioYDisponibilidad, datosDemograficos, cobertura,} = useSelector( ({nuevoTarifario}) => nuevoTarifario);

  const obtenerContenidoDePasos = (step) => {
    switch (step) {
      case 0:
        return <DatosDeLMedioEscrito activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} datosDelMedioEscrito={datosDelMedioEscrito} />
      case 1:
        return renderizarAlSiguientePaso(rest.steps[step])
      case 2:
        return renderizarAlSiguientePaso(rest.steps[step])
      case 3:
        return renderizarAlSiguientePaso(rest.steps[step])
      default:
        return <Typography>No existen Componente para mostrar</Typography>;
    }
  }

  const renderizarAlSiguientePaso = (currentStep) => {
    switch(currentStep?.id) {
      case 1:
        return <TarifarioYDisponibilidad activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} tarifarioYDisponibilidad={tarifarioYDisponibilidad} tipoMedio="escritos" title="TARIFA POR PÁGINA DE LOS ULTIMOS SEIS MESES, EN PÁGINAS INTERIORES A FULL COLOR." subtitle="LA TARIFA DEBE DE SER INGRESADA EN QUETZALES(Q)”, DEBE DE INCLUIR IVA Y TIMBRE DE PRENSA." titleDisponibilidad={`1. SI ES REVISTA ES UN 1/4 DE PÁGINA PARA CADA ORGANIZACIÓN POLÍTICA.
        2. SI ES PERIODICO O DIGITAL ES 1 PÁGINA PARA CADA ORGANIZACIÓN POLÍTICA.`} />
      case 2:
        return <Cobertura activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} cobertura={cobertura}/>
      case 3:
        return <DatosDemograficos activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} datosDelMedio={datosDelMedioEscrito} tarifarioYDisponibilidad={tarifarioYDisponibilidad} cobertura={cobertura} datosDemograficos={datosDemograficos} tituloModalDeConfirmacion="un nuevo medio escrito" tarifario="del medio escrito" tipoMedio="escritos" nitEmpresa={datosDeEmpresa.nit} />
      default:
        return <Typography>No existen Componente para mostrar</Typography>;
    }
  }

  const cerrarPantallaCompleta = function() { handleClose(); }

  return (
    <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={cerrarPantallaCompleta}
        title={title}
        fullscreen={true}
    >
      <Fragment>
          <Card>
              <CardContent>
                  <PasoAPasoHorizontal
                      cerrarPantallaCompleta={cerrarPantallaCompleta}
                      steps={rest.steps}
                      obtenerContenidoDePasos={obtenerContenidoDePasos}
                      activeStepProp={activeStep}
                      numberStepProp={numberStep}
                      showButtonStepper={false}
                  />
              </CardContent>
          </Card>
      </Fragment>
    </DialogoPantallaCompleta>
  );
}

export default NuevoMedioEscrito;